if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('mini-cart');
        this.submitButton = this.querySelector('[type="submit"]');
        this.variantSelector = this.querySelector('[name="id"]');
        if (this.variantSelector) {
          this.variantSelector.addEventListener("change", () => {

            document.querySelectorAll('quantity-input').forEach(qtyInput => {
              if (typeof qtyInput.resetQuantity === 'function') {
                qtyInput.resetQuantity(1);
              }
            });
             const checkedInputs = document.querySelectorAll('.complementary-products input[type="checkbox"]:checked');
                    checkedInputs.forEach(input => {
                      input.checked = false;
                    });

            if (this.submitButton?.dataset?.mainProdQty !== undefined) {
              this.submitButton.dataset.mainProdQty = "1";
            }
          });
        }

        this.submitProgram = this.querySelector('.btn_trial_program');

        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        let items = [];

        const complementaryProdContainer = document.querySelector(".complementary-products");
        this.mainProdId = this.submitButton.dataset.mainProdId;
        this.mainProdQty = this.submitButton.dataset.mainProdQty;
        
        if (complementaryProdContainer) {
          const checkboxes = complementaryProdContainer.querySelectorAll('input[type="checkbox"]:checked');

          checkboxes.forEach(checkbox => {
            const checkboxContainer = checkbox.closest(".shop-the-look-item");
            const sizeSelector = checkboxContainer.querySelector(".shop-the-look-size-selector");
            if (sizeSelector) {
              const selectedOption = sizeSelector.selectedOptions[0];
              const variantId = selectedOption.value;
              console.log("variantId" + variantId);
              const item = {
                id: variantId,
                quantity: 1
              }
              items = [...items, item];
            }
          });


          const mainQtyInput = document.querySelector('.quantity__input');
          
          const currentMainQty = parseInt(mainQtyInput?.value || 1);
            
          const secondAtcInput = document.querySelector('.second-atc-quantity');

          

          if (secondAtcInput) {
            secondAtcInput.value = this.submitButton.dataset.mainProdQty;
          } else {
            console.log(".second-atc-quantity input not found");
          }



        }
        

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        //this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const formDataProgram = this.form.closest('.saddle_trial_program');

        const metafieldOption = document.querySelector('#gullet-variants');
        const gulletSelected = metafieldOption ? metafieldOption.value : null;


        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);

          if (formDataProgram) {
            formData.append('properties[product_type]', 'trial_program')
          }
          if (gulletSelected != null) {
            formData.append('properties[gullet_size]', gulletSelected)
          }
          this.cart.setActiveElement(document.activeElement);
        }

        if (this.submitButton.classList.contains("shop-the-look-atc-btn")) {
          items.forEach((item, index) => {
            formData.append(`items[${index}][id]`, item.id);
            formData.append(`items[${index}][quantity]`, item.quantity);
          });
        }
        const formDataObject = {};
        formData.forEach((value, key) => {
          formDataObject[key] = value;
        });
        console.log("Form Data:", formDataObject);


        config.body = formData;
        // for (let pair of formData.entries()) {
        //   console.log(pair[0] + ": " + pair[1]);
        // }

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.log(response);
              
              if (
                response.status === 422 &&
                response.message?.includes('maximum quantity')
                
              ) {
                showToast('The maximum quantity for the selected product has been added to thre Cart');
                this.handleErrorMessage(response.message || "Quantity exceeds available stock.");
              }
              else if(response.status === 422 &&
                response.message?.includes('were added')) {
                  showToast(response.message);
              }
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = theme.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    const checkedInputs = document.querySelectorAll('.complementary-products input[type="checkbox"]:checked');
                    checkedInputs.forEach(input => {
                      input.checked = false;
                    });

                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            }else {
              this.cart.renderContents(response);
              document.dispatchEvent(new CustomEvent('menudrawer:open'));
              const checkedInputs = document.querySelectorAll('.complementary-products input[type="checkbox"]:checked');
              checkedInputs.forEach(input => {
                input.checked = false;
              });

              const relatedHandles = this.dataset.relatedProducts?.split(',').filter(Boolean);

         if (relatedHandles?.length) {
          const justAddedVariantId = parseInt(formData.get('id'), 10);
function formatMoney(cents) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  const value = (cents / 100).toFixed(2);
  return `$${value}`;
}
          // Check cart to decide if modal should show
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              const cartShownKey = 'giftShownCart';
              const currentCartToken = window?.ShopifyAnalytics?.meta?.page?.cart_token || 'no-token';
              let shownForCart = JSON.parse(sessionStorage.getItem(cartShownKey) || '{}');

              // --- Find the PRODUCT ID for the variant that was just added ---
              const justAddedItem = cart.items.find(item => item.id === justAddedVariantId);
              if (!justAddedItem) {
                console.log(`Variant ID ${justAddedVariantId} not found in cart. Skipping gift popup.`);
                return;
              }
              const justAddedProductId = justAddedItem.product_id;

              // --- Clean up storage for removed products (product_id-based) ---
              const cartProductIds = cart.items.map(item => item.product_id);
              shownForCart[currentCartToken] = (shownForCart[currentCartToken] || []).filter(
                pid => cartProductIds.includes(pid)
              );
              sessionStorage.setItem(cartShownKey, JSON.stringify(shownForCart));

              // --- Check if this product already had popup shown ---
              if (shownForCart[currentCartToken]?.includes(justAddedProductId)) {
                console.log(`Gift already shown for product ID ${justAddedProductId} in this cart.`);
                return;
              }

              // --- Ensure the product is still actually in cart ---
              if (!cartProductIds.includes(justAddedProductId)) {
                console.log(`Product ID ${justAddedProductId} not in cart, skipping gift popup.`);
                return;
              }

              if (!shownForCart[currentCartToken]) {
                shownForCart[currentCartToken] = [];
              }
              shownForCart[currentCartToken].push(justAddedProductId);
              sessionStorage.setItem(cartShownKey, JSON.stringify(shownForCart));

              // --- Fetch related products & show popup ---
              Promise.all(
                relatedHandles.map(handle =>
                  fetch(`/products/${handle}.js`).then(res => res.json())
                )
              ).then(products => {
  const giftContent = document.getElementById('gift-content');
const productForm = document.querySelector('product-form');
const relatedTitle = productForm?.dataset.relatedTitle || '';
const modalTitle = document.querySelector('#discount-title');

if (modalTitle && relatedTitle) {
  modalTitle.innerHTML = relatedTitle;
}

  giftContent.innerHTML = '';

  products.forEach(product => {
    const variants = product.variants.map(variant => {
      return `<option value="${variant.id}" ${!variant.available ? 'disabled' : ''}>
        ${variant.title} - ${formatMoney(variant.price)}
      </option>`;
    }).join('');
    
const firstAvailableVariant = product.variants.find(v => v.available) || null;

giftContent.innerHTML += `
  <div class="modal-product-card">
    <a href="/products/${product.handle}" style="text-decoration:none; color:inherit;text-align:start;">
      <img src="${product.images?.[0] || ''}" alt="${product.title}" style="width:100%; height:auto; margin-bottom:8px;">
      <div style="font-size:14px; margin-bottom:4px;">${product.title}</div>
    </a>
    <div>
      <div style="margin-bottom:8px;text-align:start;">
        <strong>${formatMoney(product.price)}</strong>
        ${product.compare_at_price > product.price
          ? `<s style="color:#888; font-size:12px; margin-left:5px;">${formatMoney(product.compare_at_price)}</s>`
          : ''}
      </div>

      ${product.variants.length > 1
        ? `
          <select class="variant-selector" style="margin-bottom:8px; width:100%; padding:5px;">
            ${product.variants.map(v => `
              <option value="${v.id}" ${!v.available ? 'disabled' : ''}>
                ${v.title} - ${formatMoney(v.price)}
              </option>
            `).join('')}
          </select>
        `
        : ''
      }

      ${firstAvailableVariant
        ? `
          <add-to-cart
            class="add-to-cart-btn"
            data-variant-id="${firstAvailableVariant.id}"
            data-product-id="${product.id}"
            style="width:100%; background:black; color:white; padding:8px; border:none; cursor:pointer;">
            Add to cart
          </add-to-cart>
        `
        : `
          <button
            class="add-to-cart-btn"
            disabled
            style="width:100%; background:#ccc; color:#666; padding:8px; border:none; cursor:not-allowed;">
            Sold out
          </button>
        `
      }
    </div>
  </div>
`;


document.querySelectorAll('.variant-selector').forEach(select => {
  select.addEventListener('change', e => {
    const variantId = e.target.value;
    const addToCartBtn = e.target.closest('.modal-product-card').querySelector('add-to-cart');
    addToCartBtn.setAttribute('data-variant-id', variantId);
  });
});

  const atcBtn = giftContent.querySelector(`add-to-cart[data-product-id="${product.id}"]`);
  if (atcBtn) {
    atcBtn.addEventListener('click', () => {
      // Wait a moment to ensure the fetch is triggered, then close popup
      setTimeout(() => {
        document.getElementById('gift-popup__overlay').style.display = 'none';
        document.getElementById('gift-popup').style.display = 'none';
      }, 500);
    });
  }


  });

// Show modal
document.getElementById('gift-popup__overlay').style.display = 'block';
document.getElementById('gift-popup').style.display = 'block';

const giftModal = document.getElementById('gift-popup');
const giftOverlay = document.getElementById('gift-popup__overlay');

// Prevent clicks inside modal from closing it
giftModal.addEventListener('click', e => e.stopPropagation());

// Close modal when clicking overlay
giftOverlay.addEventListener('click', () => {
  giftOverlay.style.display = 'none';
  giftModal.style.display = 'none';
});

// Close modal when clicking "add-to-cart" buttons
giftModal.querySelectorAll('add-to-cart').forEach(atcBtn => {
  atcBtn.addEventListener('click', () => {
    setTimeout(() => {
      giftOverlay.style.display = 'none';
      giftModal.style.display = 'none';
    }, 500); 
  });
});

// Close modal when clicking the × close button
const closeBtn = giftModal.querySelector('.discount-close_btn');
if (closeBtn) {
  closeBtn.addEventListener('click', () => {
    giftOverlay.style.display = 'none';
    giftModal.style.display = 'none';
  });
}

});
            });
        }

            }

          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            //this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = theme.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


function showToast(message, duration = 3000) {
  let toast = document.getElementById('custom-toast');
  let toastMessage = document.getElementById('custom-toast-message');

  // Create toast if it doesn't exist
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'custom-toast';
    toast.className = 'custom-toast';
    toast.innerHTML = `
    <div class="icon">
        <svg height="50" viewBox="0 0 512 512" width="50" xmlns="http://www.w3.org/2000/svg">
            <path fill="#fff" d="M449.07,399.08,278.64,82.58c-12.08-22.44-44.26-22.44-56.35,0L51.87,399.08A32,32,0,0,0,80,446.25H420.89A32,32,0,0,0,449.07,399.08Zm-198.6-1.83a20,20,0,1,1,20-20A20,20,0,0,1,250.47,397.25ZM272.19,196.1l-5.74,122a16,16,0,0,1-32,0l-5.74-121.95v0a21.73,21.73,0,0,1,21.5-22.69h.21a21.74,21.74,0,0,1,21.73,22.7Z"/>
        </svg>
  
    <p id="custom-toast-message"></p>
      </div>
`;

    document.body.appendChild(toast);
    toastMessage = document.getElementById('custom-toast-message');

    // Inject toast styles once
    if (!document.getElementById('custom-toast-style')) {
      const style = document.createElement('style');
      style.id = 'custom-toast-style';
      style.innerHTML = `
        .icon{
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }
        .custom-toast {
          position: fixed;
          bottom: 8rem;
          right: 2.5rem;
          background-color:red;
          color: var(--toast-text, #ffffff);
          padding: 1rem 1.25rem;
          border-radius: 6px;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
          z-index: 9999;
          opacity: 0;
          transform: translateY(20px);
          pointer-events: none;
          transition: opacity 0.3s ease-out, transform 0.3s ease-out;
          max-width: 320px;
          font-size: 14px;
          line-height: 1.4;
        }

        .custom-toast.show {
          opacity: 1;
          transform: translateY(0);
          pointer-events: auto;
        }

        @media (max-width: 640px) {
          .custom-toast {
            right: 1rem;
            left: 1rem;
            max-width: calc(100% - 2rem);
          }
        }
      `;
      document.head.appendChild(style);
    }
  }

  // Set and show message
  toastMessage.textContent = message;
  toast.classList.add('show');

  // Auto-hide
  setTimeout(() => {
    toast.classList.remove('show');
  }, duration);

}

document.addEventListener('menudrawer:open', () => {
  const header = document.querySelector('.shopify-section-header');
  if (header) {
    header.classList.remove('shopify-section-header-hidden');
    document.body.classList.remove('shopify-body-section-header-hidden');
  }
});
